// components/Loader.tsx
import Image from 'next/image';
import LoaderGif from "../../../public/loader.gif"

type LoaderProps = {
  title?: string;
};

export default function Loader({ title = '' }: LoaderProps) {
  return (
    <div className="loader-overlay">
      {/* <div className="spinner"></div> */}
      <Image
          src={LoaderGif}
          alt="Loading"
          width={250}
          height={250}
          priority 
        />
        {title && <p className="loading-text">{title}</p>}
    </div>
  );
}
